import React from "react";
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

interface TransactionHistoryProps {
  hideUserColumn?: boolean;
}

const TransactionHistory: React.FC<TransactionHistoryProps> = ({ hideUserColumn }) => {
  const navigate = useNavigate();
  const transactions = [
    {
      id: 1,
      date: "17 Feb, 2025 14:53",
      user: "Sophia Williams",
      store: "App",
      storeAddress: "Online",
      type: "Redeemed",
      points: -10,
      pointsValue: "$100",
      price: "$1,200",
      purchaseItem: "Shoes",
      status: "Success",
      receiptId: "1009826",
    },
    {
      id: 2,
      date: "24 Mar, 2025 12:53",
      user: "Liam Brown",
      store: "App",
      storeAddress: "Online",
      type: "Expired",
      points: 50,
      pointsValue: "$500",
      price: "$2,000",
      purchaseItem: "Headphones",
      status: "Success",
      receiptId: "529826",
    },
    {
      id: 3,
      date: "16 Jan, 2025 11:24",
      user: "John Smith",
      store: "App",
      storeAddress: "Online",
      type: "Earned",
      points: 150,
      pointsValue: "$1,500",
      price: "$5,000",
      purchaseItem: "Smartwatch",
      status: "Failed",
      receiptId: "1009826",
    },
    {
      id: 4,
      date: "08 Jul, 2025 14:53",
      user: "Emily Davis",
      store: "Jumeirah",
      storeAddress: "Dubai, UAE",
      type: "Earned",
      points: 27,
      pointsValue: "$270",
      price: "$900",
      purchaseItem: "Perfume",
      status: "Success",
      receiptId: "5409826",
    },
    {
      id: 5,
      date: "17 Feb, 2025 14:53",
      user: "David Miller",
      store: "App",
      storeAddress: "Online",
      type: "Redeemed",
      points: 38,
      pointsValue: "$380",
      price: "$1,500",
      purchaseItem: "T-Shirt",
      status: "Failed",
      receiptId: "1009826",
    },
    {
      id: 6,
      date: "08 Jul, 2025 14:53",
      user: "Olivia Johnson",
      store: "Store (Jumeirah)",
      storeAddress: "Dubai, UAE",
      type: "Earned",
      points: 77,
      pointsValue: "$770",
      price: "$3,000",
      purchaseItem: "Handbag",
      status: "Success",
      receiptId: "5409826",
    },
  ];

  return (
    <TableContainer className="table_container">
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Receipt ID</TableCell>
            <TableCell>Transaction Date</TableCell>
            {!hideUserColumn && <TableCell>User</TableCell>}
            <TableCell>Source</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Points</TableCell>
            <TableCell>Transaction Status</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {transactions.map((tx) => (
            <TableRow key={tx.id}>
              <TableCell>{tx.receiptId}</TableCell>

              <TableCell>{tx.date}</TableCell>
              {!hideUserColumn &&
                <TableCell>
                  <Box component="a" onClick={(e) => {
                    e.preventDefault();
                    navigate("/manage-users/detail");
                  }}
                    className="user_block click_action"><p> <b> {tx.user}</b> <span>9876543210</span> <span>john@yopmail.com</span> </p>
                  </Box>
                </TableCell>
              }
              <TableCell>{tx.store}</TableCell>

              <TableCell>{tx.type}</TableCell>
              <TableCell>
                <p
                  className={`status_btn ${tx.points > 0 ? "c_success" : "c_danger"
                    }`}
                >
                  {`${tx.points > 0 ? "+" : ""}${tx.points} pts`}
                </p>
              </TableCell>

              <TableCell>
                <p
                  className={`status_btn dark ${tx.status === "Success"
                    ? "c_success"
                    : tx.status === "Failed"
                      ? "c_danger"
                      : "c_warning"
                    }`}
                >

                  {tx.status}
                </p>
              </TableCell>
              <TableCell>
                <div className="table_actions v2">

                  <Box>

                    <IconButton
                      onClick={() => navigate("/manage-transactions/view")}>
                      <img src="/static/images/eye_icon.svg" alt="View" />
                    </IconButton>

                  </Box>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TransactionHistory;
